export const services = [
  {
    id: 1,
    icon: '24-hours.svg',
    title: "Atendimento 24 horas",
    description: "Suporte veterinário contínuo, disponível em qualquer horário para emergências e cuidados imediatos.",
    principal: true
  },
  {
    id: 2,
    icon: 'stethoscope.svg',
    title: "Consultas",
    description: "Avaliação completa e personalizada para garantir o bem-estar e a saúde do seu pet.",
  },
  {
    id: 3,
    icon: 'microscope.svg',
    title: "Exames",
    description: "Diagnósticos precisos com tecnologia moderna para resultados rápidos e confiáveis.",
  },
  {
    id: 4,
    icon: 'vet.svg',
    title: "Cirurgia",
    description: "Procedimentos cirúrgicos realizados com segurança, técnica e acompanhamento profissional.",
  },
  {
    id: 5,
    icon: 'clinic.svg',
    title: "Internamento",
    description: "Ambiente confortável e monitorado para pets que necessitam de cuidados intensivos.",
  },
  {
    id: 6,
    icon: 'vaccine.svg',
    title: "Medicação",
    description: "Dispensação e orientação de medicamentos adequados para cada tratamento.",
  },
];

export const services_care = [
  {
    id: 1,
    label: "Banho e Tosa",
    image: "/services/grooming.svg",
  },
  {
    id: 2,
    label: "Venda de Rações e Acessórios",
    image: "/services/pet-food.svg",
  },
  {
    id: 3,
    label: "Hidratação e Cuidados Estéticos",
    image: "/services/dog-grooming.svg",
  },
  {
    id: 4,
    label: "Hospedagem e Day Care",
    image: "/services/clinic.svg",
  },
];